/**
 * mc-harmonizacao.js — Manifesto (task 0010)
 *
 * Interatividade leve da página de evento de Harmonização
 * (sections/main-product-harmonizacao.liquid). Asset TEMPLATE-ONLY (DP-11) —
 * carregado só por essa section, não em theme.liquid.
 *
 *   1. Countdown — atualiza o nó `[data-mc-hz-countdown-value]` a cada 30s
 *      (granularidade em minutos, "urgência calma" — R-2). Esse nó é
 *      `aria-hidden="true"` (AJ-6): a fonte acessível da data é a info-row
 *      estática já renderizada pelo servidor. Sem JS, o nó fica parado no
 *      valor estático inicial (fallback no-JS — critério 10).
 *   2. Total (n) — recalcula `variant.price × qty` a cada mudança de
 *      quantidade (AJ-2: nunca um preço constante — o preço unitário vem de
 *      `data-mc-hz-unit-price`, escrito pelo Liquid a partir de
 *      `variant.price`). Único `aria-live="polite"` do widget (AJ-8).
 *   3. Aviso de limite (`data-mc-hz-limit-msg`) — `aria-live` PRÓPRIO,
 *      distinto do Total (AJ-8/critério 19); alternado via `hidden`, texto
 *      já vem pronto do Liquid/locale (nada hardcoded em JS — critério 23).
 *
 * O add-to-cart em si é do <product-form> do Dawn (product-form.js), que
 * abre a gaveta lateral Manifesto — não reimplementado aqui (DP-2/AJ-12).
 */

(function () {
  'use strict';

  var BRL = (window.Intl && Intl.NumberFormat)
    ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
    : null;

  function formatBRL(value) {
    if (BRL) return BRL.format(value);
    return 'R$ ' + value.toFixed(2).replace('.', ',');
  }

  // Countdown "urgência calma": granularidade em minutos, atualização a
  // cada 30s (nunca por segundo — lição 0009/AJ-2: aria-hidden cobre o
  // anúncio a leitor de tela, mas atualização por segundo também é ruído/
  // custo de reflow desnecessário).
  function initCountdown(root) {
    var box = root.querySelector('[data-mc-hz-countdown]');
    var valueEl = root.querySelector('[data-mc-hz-countdown-value]');
    if (!box || !valueEl) return;

    var tsMs = parseInt(box.getAttribute('data-event-timestamp-ms'), 10);
    if (!tsMs || isNaN(tsMs)) return;

    var strStarted = box.getAttribute('data-str-started');
    var strDaySuffix = box.getAttribute('data-str-day-suffix') || 'd';
    var strHourSuffix = box.getAttribute('data-str-hour-suffix') || 'h';
    var strMinuteSuffix = box.getAttribute('data-str-minute-suffix') || 'min';

    function render() {
      var diff = tsMs - Date.now();
      if (diff <= 0) {
        if (strStarted) valueEl.textContent = strStarted;
        return false;
      }
      var totalMinutes = Math.floor(diff / 60000);
      var days = Math.floor(totalMinutes / 1440);
      var hours = Math.floor((totalMinutes % 1440) / 60);
      var minutes = totalMinutes % 60;
      var parts = [];
      if (days > 0) parts.push(days + strDaySuffix);
      parts.push(hours + strHourSuffix);
      parts.push(minutes + strMinuteSuffix);
      valueEl.textContent = parts.join(' ');
      return true;
    }

    if (!render()) return;
    var intervalId = setInterval(function () {
      if (!render()) clearInterval(intervalId);
    }, 30000);
  }

  // Total (n) — AJ-2: sempre variant.price × qty, nunca constante.
  function initQtyTotal(root) {
    var qtyInput = root.querySelector('[data-mc-hz-qty]');
    var priceEl = root.querySelector('[data-mc-hz-unit-price]');
    var totalEl = root.querySelector('[data-mc-hz-total]');
    var limitEl = root.querySelector('[data-mc-hz-limit-msg]');
    if (!qtyInput || !priceEl || !totalEl) return;

    var unitCents = parseInt(priceEl.getAttribute('data-mc-hz-unit-price'), 10) || 0;
    var ticketSingular = totalEl.getAttribute('data-str-ticket-singular') || '';
    var ticketPlural = totalEl.getAttribute('data-str-ticket-plural') || '';

    function updateLimitMsg(qty) {
      if (!limitEl) return;
      var max = parseInt(qtyInput.getAttribute('max'), 10);
      limitEl.hidden = isNaN(max) || qty < max;
    }

    function render() {
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var total = (unitCents * qty) / 100;
      var label = qty === 1 ? ticketSingular : ticketPlural;
      totalEl.textContent = formatBRL(total) + (label ? ' — ' + qty + ' ' + label : '');
      updateLimitMsg(qty);
    }

    qtyInput.addEventListener('change', render);
    qtyInput.addEventListener('input', render);

    // Feedback imediato ao clicar "+" já no máximo: quantity-input.js
    // (global.js) faz input.stepUp() nativo, que é no-op silencioso (sem
    // disparar 'change') quando o valor já está no atributo max — sem este
    // listener extra no botão, o limitMsg nunca apareceria nesse caso.
    var plusBtn = root.querySelector('.mc-hz__stepper .quantity__button[name="plus"]');
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        var qty = parseInt(qtyInput.value, 10) || 1;
        updateLimitMsg(qty);
      });
    }

    render();
  }

  function init() {
    var root = document.querySelector('[data-section-type="main-product-harmonizacao"]');
    if (!root) return;
    initCountdown(root);
    initQtyTotal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
